module.exports = __webpack_public_path__ + "img/progressBarBg.b841a40b.png";